import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { Search } from '@material-ui/icons';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import ModalFilterBPartner from 'components/Tvendo/Common/ModalFilterBPartner';
import { WithApp } from 'contexts/appContext';
import { ImportExcel } from 'components/Tvendo/Common/ImportExcel';
import { wsGetAll, wsGet, wsFindBy } from 'services/WService.js';
import FilterArticle from 'hooks/FilterArticle';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';

export default WithApp(function ModalCuotaProvider(props) {
  const cuota = props.model;
  const customerPortfolioB = props.model;

  const [dataImport, setDataImport] = useState({});
  const [sellers, setSellers] = useState([]);
  const [families, setFamilies] = useState([]);
  const [products, setProducts] = useState([]);
  
  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);
  const [dataChanging, setDataChanging] = useState(customerPortfolioB);

  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  async function listSeller() {
    let response = await wsGetAll('sale/seller-quote-winter/sellers-bureau');
    if (response.success) setSellers(response.data);
  }

  async function listFamilies() {
    let response = await wsFindBy('sale/cobertura-referencia-winter/list-family ');
    if (response.success) setFamilies(response.data);
  }

  async function listProducts() {
    let response = await wsFindBy('sale/cobertura-referencia-winter/list-product ');
    if (response.success) setProducts(response.data);
  }

  useEffect(() => {
    if (cuota.open) setBPartnerSelect(undefined);
  }, [cuota.open]);

  useEffect(() => {
    if (dataImport?.success) {
      console.log("Importación exitosa", dataImport);
  
      setDataChanging((prev) => ({
        ...prev,
        SlpCode: null,
      }));
  
      setBPartnerSelect({
        success: dataImport.success,
        customers: dataImport.data.map((item) => {
          return {
            SlpCode: item.CODIGOVENDEDOR,
            ItemCode: item.CODIGOITEM.toString(),
            Meta: item.META,
            Tipo: (item.TIPO.toString()).toUpperCase(),
          };
        }),
        SlpName: dataImport.nameFile,
      });
    } else if (dataImport?.success === false) {
      console.log("Importación fallida", dataImport);
      setBPartnerSelect(undefined);
    }
  }, [dataImport]);

  useEffect(() => {
    if (bPartnerSelect?.SlpCode) {
      setDataChanging((prev) => ({
        ...prev,
        SlpCode: bPartnerSelect?.SlpCode || '',
      }));
    }
  }, [bPartnerSelect]);

  useEffect(() => {
    if (customerPortfolioB.open) {
      if (!customerPortfolioB.id) {
        listSeller();
        listFamilies();
        listProducts();
      }
      setDataChanging(customerPortfolioB);
    }
  }, [customerPortfolioB.open]);

  const handleItemChange = (type, value) => {
    if (type === 'F') {
      handleChange('ItemCode', value.id.toString());
      handleChange('id', value.id);
    } else {
      handleChange('ItemCode', value.ItemCode);
    }
    setDataImport(null);
  };
    
  return (
    <>
      <Modal
        title={`Nueva Cobertura de referencia`}
        model={{ open: cuota.open }}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity={
          dataChanging.SlpCode
            ? 'sale/cobertura-referencia-winter'
            : 'sale/cobertura-referencia-winter/multiple'
        }
        dataForce={
          dataChanging.SlpCode
            ? {
                SlpCode: dataChanging.SlpCode,
                Tipo: dataChanging.Tipo,
                ItemCode: dataChanging.ItemCode,
                Meta: dataChanging.Meta,
              }
            : {
                SlpCode: cuota.valueSearch?.SlpCode,
                customers: bPartnerSelect?.customers,
                force: 'N'
              }
        }
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="Periodo"
          margin="normal"
          defaultValue={moment(cuota.valueSearch?.Periodo).format('YYYY-MM') || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <span style={{ display: 'flex', alignItems: 'flex-end' }}>
          <Autocomplete
            disableClearable
            options={sellers}
            getOptionLabel={(item) => `${item.SlpName} (Código: ${item.SlpCode})`}
            renderInput={(params) => (
              <TextField {...params} label="Vendedor" margin="normal" fullWidth />
            )}
            onChange={(e, item) => {handleChange('SlpCode', item?.SlpCode); setDataImport(null);}}
            value={sellers.find((seller) => seller.SlpCode === dataChanging.SlpCode) || null}
            style={{ flexGrow: 1, marginRight: '10px' }}
          />
          <ImportExcel
            setDataImport={setDataImport}
            btnColor="success"
            validDuplicate="CODIGOITEM"
            sortDuplicate="CODIGOITEM"
            downTemplate={{
              fileNameDown: `${moment(cuota?.valueSearch?.Periodo).format('YYYY-MM')}_Plantilla de datos de cobertura de referencia`,
              fields: ['CODIGOVENDEDOR','TIPO','CODIGOITEM','META']
            }}
          />
        </span>
        {dataImport?.success && (
          <p style={{ color: '#07c107', marginTop: '10px', fontSize: '14px' }}>
            Archivo importado: {dataImport.nameFile}
          </p>
        )}
        {dataChanging.SlpCode ? (
          <>
            <FormControl fullWidth margin="normal" size="small">
              <InputLabel>Tipo</InputLabel>
              <Select
                required
                value={dataChanging.Tipo || ''}
                inputProps={{
                  name: 'Tipo',
                  onChange: (e) => handleChange('Tipo', e.target.value),  
                }}
              >
                <MenuItem value="F">Familia</MenuItem>
                <MenuItem value="P">Producto</MenuItem>
              </Select>
            </FormControl>
          </>
        ) : undefined}
        {dataChanging.SlpCode ? dataChanging.Tipo === 'F' ? (
          <>
            <Autocomplete
              disableClearable
              options={families}
              getOptionLabel={(item) => `${item.description}`}
              renderInput={(params) => (
                <TextField {...params} label="Familia" margin="normal" fullWidth />
              )}
              onChange={(e, item) => {handleItemChange('F', item); setDataImport(null);}}
              value={families.find((family) => family.id === dataChanging.id) || null}
              style={{ flexGrow: 1, marginRight: '10px' }}
            />
            <TextField
              label="Meta"
              fullWidth
              type="number"
              name="Meta"
              margin="normal"
              value={dataChanging.Meta || ''}
              onChange={(e) => handleChange('Meta', e.target.value)}
              required
            />
          </>
        ): undefined : undefined}
        {dataChanging.SlpCode ? dataChanging.Tipo === 'P' ? (
          <>
            <Autocomplete
              disableClearable
              options={products}
              getOptionLabel={(item) => `${item.ItemName}`}
              renderInput={(params) => (
                <TextField {...params} label="Producto" margin="normal" fullWidth />
              )}
              onChange={(e, item) => {handleItemChange('P', item); setDataImport(null);}}
              value={products.find((product) => product.ItemCode === dataChanging.ItemCode) || null}
              style={{ flexGrow: 1, marginRight: '10px' }}
            />
            <TextField
              label="Meta"
              fullWidth
              type="number"
              name="Meta"
              margin="normal"
              value={dataChanging.Meta || ''}
              onChange={(e) => handleChange('Meta', e.target.value)}
              required
            />
          </>
        ): undefined : undefined}
      </Modal>
    </>
  );
});
